import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../Components/ui/dialog";
import { Button } from "../../Components/ui/button";
import { Label } from "../../Components/ui/label";
import axios from "axios";
import { toast } from "sonner";
import { useDebounce } from 'use-debounce'; // (instale: npm install use-debounce)

export function TransferLoadModal({ isOpen, onClose, load, onTransferRequested }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm] = useDebounce(searchTerm, 500); // Debounce de 500ms
  const [searchResults, setSearchResults] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (debouncedSearchTerm.length > 1) {
      const fetchCompanies = async () => {
        setIsLoading(true);
        try {
          const token = localStorage.getItem("token");
          const response = await axios.get(`https://new.cajuu.app/api/companies/search?query=${debouncedSearchTerm}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setSearchResults(response.data.data);
        } catch (error) {
          console.error("Failed to search companies:", error);
          toast.error("Failed to search for companies.");
        } finally {
          setIsLoading(false);
        }
      };
      fetchCompanies();
    } else {
      setSearchResults([]);
    }
  }, [debouncedSearchTerm]);

  const handleConfirm = async () => {
    if (!selectedCompany || !load) {
      toast.warning("Please select a company to transfer the load to.");
      return;
    }

    setIsLoading(true);
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `https://new.cajuu.app/api/loadtransport/${load.id}/request-transfer`,
        { destination_company_id: selectedCompany.id },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Transfer request sent successfully!");
      onTransferRequested();
      onClose();
    } catch (error) {
      console.error("Failed to request transfer:", error);
      const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
      toast.error(`Error: ${errorMessage}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-zinc-800 border-zinc-700">
        <DialogHeader>
          <DialogTitle>Transfer LoadTransport to Another Company</DialogTitle>
        </DialogHeader>
        <div className="mt-4 space-y-4">
            <div className="relative">
                 <Label htmlFor="company_search" className="absolute -top-[10px] text-[0.8rem] bg-[#1c1b19] px-1 left-2">
                    Search by Company Name or DOT
                 </Label>
                <input
                    id="company_search"
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Type to search..."
                    className="w-full py-2 px-3 border border-white text-white bg-transparent rounded-md"
                />
            </div>
            {searchResults.length > 0 && (
                <div className="max-h-48 overflow-y-auto border border-zinc-700 rounded-md p-2">
                    {searchResults.map((company) => (
                        <div
                            key={company.id}
                            onClick={() => {
                                setSelectedCompany(company);
                                setSearchTerm(`${company.id} - ${company.partner_company_name} (DOT: ${company.dot})`);
                                setSearchResults([]);
                            }}
                            className="p-2 hover:bg-zinc-700 cursor-pointer rounded-md border border-gray-800 bg-gray-800 mb-2 last:mb-0"
                        >
                            <p className="font-semibold text-gray-300">{company.id} - {company.partner_company_name}</p>
                            <p className="text-sm text-gray-400">DOT: {company.dot}</p>
                        </div>
                    ))}
                </div>
            )}
            {selectedCompany && !searchResults.length && (
                 <p className="text-sm text-green-400">Selected: {selectedCompany.partner_company_name}</p>
            )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>Cancel</Button>
          <Button onClick={handleConfirm} disabled={!selectedCompany || isLoading}>
            {isLoading ? "Sending Request..." : "Confirm Transfer"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
